import ModelEntity from "../model-entity";
import {EntityType} from "../../gd/const/item";
import DatetimeUtils from "../../gd/utils/datetime-utils";
import {AttendanceType} from "./const";
import ErrorProto from "../../gd/validation/error";
import ErrorFieldRequired from "../../gd/validation/error-field-required";


export default class AttendanceEvent extends ModelEntity {

    public pairId         : ID
    public userId         : ID
    public companyId      : ID
    public officeId       : ID
    public createdByUserId: ID
    public type           : AttendanceType
    public timestamp      : Moment
    public momentCreated  : Moment
    public isDeleted      : boolean
    public ipAddress      : string
    public deviceType     : string
    public deviceInfo     : string
    public comment        : string

    private _date           : Moment      // user date

    constructor(data: any) {
        super(data['id'], EntityType.ATTENDANCE_EVENT);

        this.pairId         = data['pairId']
        this.userId         = data['userId']
        this.companyId      = data['companyId']
        this.officeId       = data['officeId']
        this.createdByUserId= data['createdByUserId']
        this.type           = data['type']
        this._date          = data['date'] ? DatetimeUtils.dateToMoment(data['date']) : moment()
        this.timestamp      = data['timestamp'] ? DatetimeUtils.datetimeToMoment(data['timestamp']) : moment()
        this.momentCreated  = data['momentCreated'] ? DatetimeUtils.datetimeToMoment(data['momentCreated']) : moment()
        this.isDeleted      = data['isDeleted']
        this.ipAddress      = data['ipAddress']
        this.deviceType     = data['deviceType']
        this.deviceInfo     = data['deviceInfo']
        this.comment        = data['comment']
    }

    get date():Moment {
        return this._date
    }

    set date(date:Moment) {
        this._date = date

        if (this.timestamp) {
            // from current time stamp mi berem hour minutes ... i eto uze LOCAL TIME (!)
            // clone this._date... set hours minutes

            const date      = _.cloneDeep(this.date)
            const timestamp = _.cloneDeep(this.timestamp)

            this.timestamp = date.set({hour: timestamp.hours(), minute: timestamp.minutes()})

        }
    }


    validate():ErrorProto[] | null  {
        const errors : any[] = []

        if (!this.date && this.type === AttendanceType.CLOCKED_IN) errors.push(new ErrorFieldRequired(gd.fields.attendance.date))
        if (!this.createdByUserId && this.type === AttendanceType.CLOCKED_IN) errors.push(new ErrorFieldRequired(gd.fields.attendance.createdByUserId))
        if (!this.officeId && this.type === AttendanceType.CLOCKED_IN) errors.push(new ErrorFieldRequired(gd.fields.attendance.officeId))
        if (!this.timestamp) errors.push(new ErrorFieldRequired(gd.fields.attendance.timestamp))

        if (_.isEmpty(errors)) return null
        else return errors
    }


    toJSON() {
        return {
            pairId          : this.pairId,
            userId          : this.userId,
            companyId       : this.companyId,
            officeId        : this.officeId,
            createdByUserId : this.createdByUserId,
            type            : this.type,
            date            : this.date,
            timestamp       : this.timestamp,
            momentCreated   : this.momentCreated,
            isDeleted       : this.isDeleted,
            ipAddress       : this.ipAddress,
            deviceType      : this.deviceType,
            deviceInfo      : this.deviceInfo,
            comment         : this.comment
        }
    }
}
